import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "@fortawesome/fontawesome-free/css/all.css";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import axios from "axios";
import { sync } from "vuex-router-sync";
import Chart from "chart.js";
import Highcharts from "highcharts";
import HighchartsVue from "highcharts-vue";

import svgJs from "./plugins/vueSvgPlugin";
import Notifications from "vue-notification";
import ImageUploader from "vue-image-upload-resize";
import Vuelidate from "vuelidate";

Vue.use(Vuelidate);
Vue.use(svgJs);
Vue.use(Notifications);
Vue.use(HighchartsVue);
Vue.use(Highcharts);
Vue.use(ImageUploader);

Vue.prototype.$axios = axios;
Vue.prototype.$charts = Chart;
Vue.prototype.$Highcharts = Highcharts;

// Vue.prototype.$axios.defaults.baseURL = 'https://www.nxtagro.io';

// Vue.prototype.$axios.defaults.baseURL = "http://localhost:3000";

// Vue.prototype.$axios.defaults.baseURL = "https://app.nxtagro.io";
Vue.prototype.$axios.defaults.baseURL = "https://backend-op.nxtagro.io";

Vue.config.productionTip = false;

Vue.use(Vuetify, {
  iconfont: "fa",
});

sync(store, router);

var vm = new Vue({
  router,
  store,
  render: (h) => h(App),
});
vm.$mount("#app");

export const vueInstance = vm;
